'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var cc = require('card-validator');
var dateFns = require('date-fns');
var dateFnsTz = require('date-fns-tz');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var cc__default = /*#__PURE__*/_interopDefaultLegacy(cc);

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var poll = function (_a) {
    var fn = _a.fn, validate = _a.validate, _b = _a.interval, interval = _b === void 0 ? 2000 : _b, _c = _a.maxAttempts, maxAttempts = _c === void 0 ? 30 : _c;
    var attempts = 0;
    var executePoll = function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fn()];
                case 1:
                    result = _a.sent();
                    attempts += 1;
                    if (validate(result)) {
                        return [2 /*return*/, resolve(result)];
                    }
                    if (maxAttempts && attempts === maxAttempts) {
                        return [2 /*return*/, reject(new Error('Max attempts exceeded.'))];
                    }
                    return [2 /*return*/, setTimeout(executePoll, interval, resolve, reject)];
            }
        });
    }); };
    return new Promise(executePoll);
};

var classname = function () {
    var classnames = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classnames[_i] = arguments[_i];
    }
    return "".concat(classnames.filter(function (c) { return !!c; }).join(' '));
};

var msgMap = {
    required: 'Required',
    email: 'Invalid email address',
    phoneNumber: 'Invalid phone number, must be 10 digits',
    zipCode: "Invalid, must be 5 digits",
    zipCodePlus4: "Enter a valid zip code",
    maxAttendees: 'Total event attendance cannot exceed 5000',
    minValue1: 'Must be at least 1',
    creditCardNumber: 'Invalid credit card',
    creditCardDate: 'Invalid expiration date',
    creditCardCvv: 'Invalid CVV',
    notZero: 'Must not be 0',
    arrayNotEmpty: 'Must not be empty',
    alphaNumeric: 'Only alphanumeric characters',
    firstCharacterIsNumber: 'First character is not a number',
    fourDigits: 'Must be 4 digits',
    fiveDigits: 'Must be 5 digits',
    notNull: 'Value can not be null',
    notTrue: 'Value can not be true',
    facilityOtherAdditionalInsuredZipCode: 'Invalid. Valid examples: 90210 or 53203-2104',
    dateOfBirth: 'Invalid date of birth'
};
/**
 * @description helper method to map error message to field meta prop
 *
 * - if a redux form meta is provided - does nothing and returns the meta
 * - if a RxForm control is provided as meta, its FormErrors are mapped to an error message and result returned
 */
var mapExtendedErrors = function (meta, options) {
    var errorMessages = __assign(__assign({}, msgMap), options === null || options === void 0 ? void 0 : options.messages);
    if (meta.errors) {
        var firstErrorKey = Object.keys(meta.errors).find(function (key) { return meta.errors[key]; });
        var errorMsg = firstErrorKey
            ? errorMessages[firstErrorKey] || 'Error'
            : undefined;
        return __assign(__assign({}, meta), { error: errorMsg });
    }
    else {
        return meta;
    }
};

var validateDigits = function (value, digits) {
    return value && new RegExp("^([0-9]{".concat(digits, "})$"), 'i').test(value)
        ? false
        : true;
};
var zipCode = function (value) {
    return validateDigits(value, 5) ? msgMap.zipCode : undefined;
};
var facilityOtherAdditionalInsuredZipCode = function (value) {
    value = value.toString();
    // 90210 or 90210-0120 or empty
    if ((value && /^\d{5}(?:-\d{4})?$/i.test(value)) || !value) {
        return undefined;
    }
    return msgMap.facilityOtherAdditionalInsuredZipCode;
};
var notZero = function (value) {
    if (required(value))
        return undefined;
    if (value === null || value === undefined)
        return undefined;
    var isZero = Number(value) === 0;
    return isZero ? msgMap.notZero : undefined;
};
var required = function (value) {
    return (typeof value === 'string' && value.trim()) ||
        typeof value === 'number' ||
        (typeof value === 'boolean' && value === true) ||
        (typeof value === 'object' && Boolean(value))
        ? undefined
        : msgMap.required;
};
var arrayNotEmpty = function (value) {
    return !value.length ? msgMap.arrayNotEmpty : undefined;
};
var maxLength = function (max) {
    return function (value) {
        return value && String(value).length > max
            ? "Must be ".concat(max, " characters or less")
            : undefined;
    };
};
var minLength = function (min) {
    return function (value) {
        return value && String(value).length < min
            ? "Must be ".concat(min, " characters or more")
            : undefined;
    };
};
var number = function (value) {
    return value && isNaN(Number(value)) ? 'Must be a number' : undefined;
};
var minValue = function (min) {
    return function (value) {
        return (value && Number(value) < min) || isNaN(Number(value))
            ? "Must be at least ".concat(min)
            : undefined;
    };
};
var maxValue = function (max) {
    return function (value) {
        return (value && Number(value) > max) || isNaN(Number(value))
            ? "Must be less or equals ".concat(max)
            : undefined;
    };
};
var oneOf = function (values) {
    return function (value) {
        return value && !values.includes(value)
            ? "Must be one of: ".concat(values.join(', '))
            : undefined;
    };
};
// regex below from http://emailregex.com/
var email = function (value) {
    return value &&
        !/^(([^<>()[\]\\.,;:\s@"]{1,64}(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"){1,64})@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value)
        ? msgMap.email
        : undefined;
};
var alphaNumeric = function (value) {
    return value && !/^[a-zA-Z0-9]*$/.test(value) ? msgMap.alphaNumeric : undefined;
};
var phoneNumber = function (value) {
    // (XXX) XXX-XXXX
    return value && !/^((\([0-9]{3}\)) [0-9]{3}-[0-9]{4})$/.test(value)
        ? msgMap.phoneNumber
        : undefined;
};
var creditCardNumber = function (blacklisted) {
    if (blacklisted === void 0) { blacklisted = []; }
    return function (value) {
        var onlyNums = value ? value.replace(/[^\d]/g, '') : '';
        return onlyNums &&
            (!cc__default["default"].number(onlyNums).isValid || blacklisted.includes(onlyNums))
            ? msgMap.creditCardNumber
            : undefined;
    };
};
var creditCardDate = function (value) {
    return cc__default["default"].expirationDate(value).isValid ? undefined : msgMap.creditCardDate;
};
var creditCardCvv = function (value, allValues) {
    var length;
    var card = cc__default["default"].number(allValues.payeeCardNum);
    if (card.card && card.card.code) {
        length = card.card.code.size;
    }
    var cvv = cc__default["default"].cvv(value, length);
    return cvv.isValid ? undefined : msgMap.creditCardCvv;
};
var firstCharacterIsNumber = function (value) {
    return value && /^\d$/.test(value.charAt(0))
        ? undefined
        : msgMap.firstCharacterIsNumber;
};
var zipCodePlus4 = function (value) {
    return new RegExp("^[0-9]{5}(-[0-9]{4})?$").test(value)
        ? undefined
        : msgMap.zipCodePlus4;
};
var fourDigits = function (value) { return validateDigits(value, 4); };
var fiveDigits = function (value) { return validateDigits(value, 5); };
var notNull = function (value) {
    return value !== null ? undefined : msgMap.notNull;
};
var notTrue = function (value) {
    return !value ? undefined : msgMap.notTrue;
};

var validators = /*#__PURE__*/Object.freeze({
    __proto__: null,
    zipCode: zipCode,
    facilityOtherAdditionalInsuredZipCode: facilityOtherAdditionalInsuredZipCode,
    notZero: notZero,
    required: required,
    arrayNotEmpty: arrayNotEmpty,
    maxLength: maxLength,
    minLength: minLength,
    number: number,
    minValue: minValue,
    maxValue: maxValue,
    oneOf: oneOf,
    email: email,
    alphaNumeric: alphaNumeric,
    phoneNumber: phoneNumber,
    creditCardNumber: creditCardNumber,
    creditCardDate: creditCardDate,
    creditCardCvv: creditCardCvv,
    firstCharacterIsNumber: firstCharacterIsNumber,
    zipCodePlus4: zipCodePlus4,
    fourDigits: fourDigits,
    fiveDigits: fiveDigits,
    notNull: notNull,
    notTrue: notTrue
});

// Parse address component provided by Google Places
var parseAddress = function (addressComponents, locationTypes, formattedAddress, placeName, usTerritories) {
    if (!addressComponents ||
        !locationTypes ||
        !formattedAddress ||
        !placeName ||
        !usTerritories) {
        return null;
    }
    var address = {
        address1: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        companyName: '',
        addressType: ['']
    };
    var types = [
        'locality',
        'sublocality',
        'sublocality_level_1',
        'sublocality_level_2',
        'sublocality_level_3',
        'sublocality_level_4',
        'sublocality_level_5',
        'administrative_area_level_3',
    ];
    var typeIndex = types.length;
    var tempCity = null;
    addressComponents.forEach(function (e) {
        var val = e.long_name;
        if (e.types.includes('street_number')) {
            address.address1 = val;
        }
        if (e.types.includes('route')) {
            if (address.address1) {
                address.address1 += " ".concat(e.long_name);
            }
            else {
                address.address1 = val;
            }
        }
        if (typeIndex !== 0) {
            types.forEach(function (type) {
                if (e.types.includes(type) && types.indexOf(type) < typeIndex) {
                    typeIndex = types.indexOf(type);
                    address.city = val;
                }
            });
        }
        if (e.types.includes('administrative_area_level_1')) {
            address.state = e.short_name;
        }
        if (e.types.includes('administrative_area_level_2')) {
            tempCity = e.long_name;
        }
        if (e.types.includes('postal_code')) {
            address.zip = val;
        }
        if (e.types.includes('country')) {
            address.country = e.short_name;
        }
        if (address.country === 'USA') {
            address.country = 'US';
        }
    });
    // Puerto Rico and Virgin Islands are received as countries.
    // This parses them into states and reinstates US as country
    if (usTerritories.includes(address.country)) {
        if (!address.city && tempCity) {
            address.city = String(tempCity);
        }
        address.state = address.country;
        address.country = 'US';
    }
    // If address_components do not contain street number and name, but formatted_address contains address, parse formatted_address and set it to address1.
    // Add other location types to be matched as necessary: https://developers.google.com/places/supported_types
    if (!address.address1 &&
        address.city &&
        address.state &&
        address.zip &&
        address.city.toLowerCase() !== placeName.toLowerCase() &&
        formattedAddress.split(',').length >= 3) {
        var matchTypes = ['establishment'];
        var result = matchTypes.filter(function (n) {
            return locationTypes.indexOf(n) > -1;
        });
        if (result.length > 0) {
            var newAddress = '';
            if (usTerritories.includes(address.state)) {
                newAddress = formattedAddress.split(',')[0];
            }
            else if (formattedAddress.split(',').length > 3) {
                newAddress = formattedAddress.replace(/(,[^,]*){3}$/g, '');
            }
            address.address1 = newAddress;
        }
    }
    // Ensures address1 is not empty/null. This permits venues without address1 but contains
    // all other address parts to be selected but only if 'city' isn't also
    // equal to 'placeName'
    if (placeName &&
        !address.address1 &&
        address.city &&
        placeName.toLowerCase() !== address.city.toLowerCase()) {
        address.companyName = placeName;
        address.address1 = placeName;
        // These conditions below are strictly for UI (Venue section).
        // It prevents duplication when placeName is essentiallly address1
        // (e.g. placeName: 1 Main St vs. address1: 1 Main Street)
    }
    else if (!placeName && address.address1) {
        address.companyName = null;
        // Furthermore, because Virgin Islands is working towards streamlined
        // addressing consistent with the rest of the country, some of their
        // addresses lack numbers, so we don't want to compare those addresses
        // with placeNames
    }
    else if (placeName && address.address1) {
        if (placeName === address.address1 ||
            (placeName !== address.address1 &&
                placeName.charAt(0) === address.address1.charAt(0) &&
                !firstCharacterIsNumber(placeName)))
            address.companyName = null;
        else {
            address.companyName = placeName;
        }
    }
    address.addressType = locationTypes;
    return address;
};

var scrollToError = function (options) {
    if (options === void 0) { options = {
        block: 'center',
        inline: 'nearest',
        behavior: 'smooth'
    }; }
    setTimeout(function () {
        var errors = document.getElementsByClassName('form-error');
        if (errors.length) {
            errors[0].scrollIntoView(options);
        }
    }, 300);
};

var normalizeEmail = function (value) {
    return value && value.replace(/\s/g, '').toLowerCase();
};
var normalizePhone = function (value) {
    if (!value) {
        return value;
    }
    var onlyNums = value.replace(/[^\d]/g, '');
    if (onlyNums.length <= 3) {
        return onlyNums;
    }
    if (onlyNums.length <= 7) {
        return "(".concat(onlyNums.slice(0, 3), ") ").concat(onlyNums.slice(3));
    }
    return "(".concat(onlyNums.slice(0, 3), ") ").concat(onlyNums.slice(3, 6), "-").concat(onlyNums.slice(6, 10));
};
// Credit Cards
var normalizeCreditCard = function (value) {
    var onlyNums = value ? value.replace(/[^\d]/g, '') : '';
    if (!onlyNums)
        return onlyNums;
    var card = cc__default["default"].number(onlyNums);
    var out = onlyNums;
    var gaps = [];
    var length = 19;
    if (card.card) {
        if (card.card.lengths) {
            length = card.card.lengths.reduce(function (previous, current) {
                return Math.max(previous, current);
            });
        }
        if (card.card.gaps) {
            gaps = card.card.gaps.reverse();
        }
    }
    out = out.substring(0, length);
    gaps.forEach(function (gap) {
        if (out.length > gap) {
            out = "".concat(out.substring(0, gap), " ").concat(out.substring(gap));
        }
    });
    return out;
};
var normalizeCVV = function (value, _, allValues) {
    if (!value) {
        return '';
    }
    var number = allValues.payeeCardNum;
    var card = cc__default["default"].number(number);
    var length = 3;
    if (card.card && card.card.code) {
        length = card.card.code.size;
    }
    var out = value.replace(/[^\d]/g, '');
    out = out.substring(0, length);
    return out;
};
var normalizeCCDate = function (value) {
    var onlyNums = value.replace(/[^\d]/g, '');
    var out = onlyNums.substring(0, 4);
    if (out.length > 2) {
        out = "".concat(out.substring(0, 2), "/").concat(out.substring(2));
    }
    return out;
};
// Dates
var normalizeDate = function (value) {
    if (!value) {
        return '';
    }
    var onlyNums = value.replace(/[^\d]/g, '');
    if (onlyNums.length <= 4) {
        return onlyNums;
    }
    if (onlyNums.length <= 6) {
        return "".concat(onlyNums.slice(0, 4), "-").concat(onlyNums.slice(4));
    }
    return "".concat(onlyNums.slice(0, 4), "-").concat(onlyNums.slice(4, 6), "-").concat(onlyNums.slice(6));
};
// Digits
var normalizeNdigits = function (value, digits) {
    if (!value)
        return value;
    var onlyNums = value.replace(/[^\d]/g, '');
    return onlyNums.slice(0, digits);
};
var normalizeDigits = function (digits) { return function (value) {
    return normalizeNdigits(value, digits);
}; };
var normalize4Digits = normalizeDigits(4);
var normalize5Digits = normalizeDigits(5);
// Zip code
var normalizeZip = function (value) {
    return normalizeNdigits(value, 5);
};
var normalizeZipPlus4 = function (value) {
    var normalized = value.replace(/[^\d]/g, '');
    if (normalized.length > 5) {
        normalized = "".concat(normalized.slice(0, 5), "-").concat(normalized.slice(5));
    }
    return normalized.slice(0, 10);
};

var normalizers = /*#__PURE__*/Object.freeze({
    __proto__: null,
    normalizeEmail: normalizeEmail,
    normalizePhone: normalizePhone,
    normalizeCreditCard: normalizeCreditCard,
    normalizeCVV: normalizeCVV,
    normalizeCCDate: normalizeCCDate,
    normalizeDate: normalizeDate,
    normalizeDigits: normalizeDigits,
    normalize4Digits: normalize4Digits,
    normalize5Digits: normalize5Digits,
    normalizeZip: normalizeZip,
    normalizeZipPlus4: normalizeZipPlus4
});

// Reverses picked days to blocked days by converting indexes with value true to elements
// [false, null, true, undefined, true] becomes [2, 4]
var pickedToBlockedDays = function (daysOfWeekPicked) {
    return [0, 1, 2, 3, 4, 5, 6].filter(function (v, i) { return daysOfWeekPicked[i] === undefined || !daysOfWeekPicked[i]; });
};
var pickedDaysToNumberedArray = function (daysOfWeekPicked) {
    return [0, 1, 2, 3, 4, 5, 6].filter(function (v, i) { return daysOfWeekPicked[i] !== undefined && daysOfWeekPicked[i]; });
};
var numberedDayArrayToString = function (dayArray) {
    var daysOfWeek = dateFns.eachDayOfInterval({
        start: dateFns.startOfWeek(new Date(), { weekStartsOn: 0 }),
        end: new Date(new Date().setDate(new Date().getDate() + 6))
    });
    var weekdays = daysOfWeek.map(function (day) { return dateFns.format(day, 'EEEE'); });
    return dayArray
        .map(function (v) { return weekdays[v]; })
        .join(', ')
        .replace(/,([^,]*)$/, ' and$1');
};
var getFirstEntry = function (dates) {
    return dates.length ? dates.reduce(function (p, c) { return (dateFns.isBefore(c, p) ? c : p); }) : null;
};
var getLastEntry = function (dates) {
    return dates.length ? dates.reduce(function (p, c) { return (dateFns.isAfter(c, p) ? c : p); }) : null;
};
var numberOfDays = function (dates) {
    return dates ? dates.length : 0;
};
var filterToUniqueDays = function (dates) {
    return dates.reduce(function (acc, date) {
        if (acc.find(function (newDate) { return dateFns.isSameDay(date, newDate); })) {
            return acc;
        }
        return acc.concat(date);
    }, []);
};
var sortDays = function (dates) {
    return dates.slice().sort(function (a, b) { return dateFns.differenceInMilliseconds(a, b); });
};
var today = function () { return new Date(); };
// FORMATTING HELPERS
// Converts date-time to 'August 8, 2019' format
var LETTERS_AND_NUMBERS_FORMAT = 'LLLL d, yyyy';
var lettersAndNumbers = function (date, timezone) {
    if (!date)
        return undefined;
    if (timezone) {
        return dateFnsTz.formatInTimeZone(new Date(date), timezone, LETTERS_AND_NUMBERS_FORMAT);
    }
    return dateFns.format(new Date(date), LETTERS_AND_NUMBERS_FORMAT);
};
var SLASH_SEPARATED_FORMAT = 'MM/dd/yy';
var slashSeparated = function (date, timezone) {
    if (!date)
        return undefined;
    if (timezone) {
        return dateFnsTz.formatInTimeZone(new Date(date), timezone, SLASH_SEPARATED_FORMAT);
    }
    return dateFns.format(new Date(date), SLASH_SEPARATED_FORMAT);
};
// Converts date-time to 'hh:mm AM/PM' format
var SIMPLE_TIME_FORMAT = 'p';
var simpleTime = function (date, timezone) {
    if (!date)
        return undefined;
    if (timezone) {
        return dateFnsTz.formatInTimeZone(new Date(date), timezone, SIMPLE_TIME_FORMAT);
    }
    return dateFns.format(new Date(date), SIMPLE_TIME_FORMAT);
};
var DATE_ONLY_FORMAT = 'yyyy-MM-dd';
var dateOnlyStringFormat = function (date, timezone) {
    if (!date)
        return undefined;
    if (timezone) {
        return dateFnsTz.formatInTimeZone(new Date(date), timezone, DATE_ONLY_FORMAT);
    }
    return dateFns.format(new Date(date), DATE_ONLY_FORMAT);
};
var getLocalMachineTimezone = function () {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
};
var timezonedDateToLocalDate = function (dateISOString, timezone) {
    var localMachineTimezone = getLocalMachineTimezone();
    if (!dateISOString)
        return undefined;
    var dateOnly = dateFnsTz.formatInTimeZone(dateISOString, timezone || localMachineTimezone, DATE_ONLY_FORMAT);
    var result = dateFnsTz.toDate(dateOnly, {
        timeZone: localMachineTimezone
    });
    return result;
};
var localDateToTimezonedDate = function (date, timezone) {
    var dateOnly = dateFns.format(date, DATE_ONLY_FORMAT);
    var result = dateFnsTz.toDate(dateOnly, {
        timeZone: timezone || getLocalMachineTimezone()
    }).toISOString();
    return result;
};
var getDaysInRange = function (_a) {
    // addDays does not have a timezone option, convert to local machine time to do proper adding
    var startDate = _a.startDate, endDate = _a.endDate, ignoredDays = _a.ignoredDays, timezone = _a.timezone;
    var currentDate = timezonedDateToLocalDate(startDate, timezone);
    var days = [];
    while (!dateFns.isAfter(currentDate, timezonedDateToLocalDate(endDate, timezone))) {
        if (!(ignoredDays === null || ignoredDays === void 0 ? void 0 : ignoredDays.includes(currentDate.getDay()))) {
            days.push(currentDate);
        }
        currentDate = dateFns.addDays(currentDate, 1);
    }
    return sortDays(filterToUniqueDays(days)).map(function (date) {
        return localDateToTimezonedDate(date, timezone);
    });
};

var dateHelpers = /*#__PURE__*/Object.freeze({
    __proto__: null,
    pickedToBlockedDays: pickedToBlockedDays,
    pickedDaysToNumberedArray: pickedDaysToNumberedArray,
    numberedDayArrayToString: numberedDayArrayToString,
    getFirstEntry: getFirstEntry,
    getLastEntry: getLastEntry,
    numberOfDays: numberOfDays,
    filterToUniqueDays: filterToUniqueDays,
    sortDays: sortDays,
    today: today,
    LETTERS_AND_NUMBERS_FORMAT: LETTERS_AND_NUMBERS_FORMAT,
    lettersAndNumbers: lettersAndNumbers,
    SLASH_SEPARATED_FORMAT: SLASH_SEPARATED_FORMAT,
    slashSeparated: slashSeparated,
    SIMPLE_TIME_FORMAT: SIMPLE_TIME_FORMAT,
    simpleTime: simpleTime,
    DATE_ONLY_FORMAT: DATE_ONLY_FORMAT,
    dateOnlyStringFormat: dateOnlyStringFormat,
    timezonedDateToLocalDate: timezonedDateToLocalDate,
    localDateToTimezonedDate: localDateToTimezonedDate,
    getDaysInRange: getDaysInRange
});

exports.classname = classname;
exports.dateHelpers = dateHelpers;
exports.mapExtendedErrors = mapExtendedErrors;
exports.normalizers = normalizers;
exports.parseAddress = parseAddress;
exports.poll = poll;
exports.scrollToError = scrollToError;
exports.validators = validators;
